import {envs} from "./evns";
import mixpanel from './third-party/mixpanel-lite'

let setting = {
  onlyForm: null
}


const subs = []
export const getSetting = () => setting
export const setSetting = s => {
  if(s.originHref) {
    setting.searchParams = getRequestParams(s.originHref)
    setting.utmStr = getUtmUrl(setting.searchParams || {}, s.localStorageUtm || {}, s.marketingUtm || {})
  }
  setting = {...setting, ...s};
  subs.forEach(x => x(setting))
}
export const subscribeSetting = func => {
  subs.push(func)
  func(setting)
}

export const send = obj => window.parent.window.postMessage(obj, getSetting().origin)

export const getUtmUrl = (searchParams, localStorageUtm, marketingUtm) => {

  const newObj = searchParams.utm_source ?  searchParams  : localStorageUtm.utm_source ?  localStorageUtm:  marketingUtm.utm_source ?  marketingUtm : {}
  let utmStr='', arr = Object.keys(newObj)
  for(let i = 0; i < arr.length; i++){
    utmStr += i !== arr.length -1 ? arr[i] + "=" + newObj[arr[i]] + "&" : arr[i] + "=" + newObj[arr[i]]
  }
  return utmStr
}

export const getRequestParams = href => {
  const utms = ['utm_source', 'utm_content', 'utm_medium', 'utm_campaign', 'utm_term']
  var params = {};
  var index = href.indexOf('?');
  if(index !== -1){
    href = href.substring(index + 1);
    var arr = href.split("&");
    var temp;
    for(var i = 0; i < arr.length; i++){
      temp = arr[i].split("=");
      const key = temp[0].toLowerCase()
      if(utms.includes(key)) params[key]=temp[1]
    }
  }
  return params;
}

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }


gtag('js', new Date());
gtag('config', envs.gtagId);

export const gTagConfig = (data, params) => {
  gtag('config', data, params);
}

export const buriedPoints = (() => {
  let mixpanelInitFlag = false;
  const defaultParams = {}
  const mixpanelInit = () => {
    mixpanelInitFlag = true;
    const setting = getSetting();
    Object.assign(defaultParams, setting.searchParams, setting.marketingUtm || {})
    mixpanel.init(envs.mixpanelToken)
  }
  return (data, params) => {
    switch(data){
      case "Sign Up Button Clicked": 
        gtag('event', 'conversion', {'send_to': 'AW-900587232/HNb9CK3-0JEYEOC9t60D'});
        break;
    }

    gtag('event', data, params)
    if (!mixpanelInitFlag) mixpanelInit()
    mixpanel.track(data, { ...defaultParams, ...params });
  }
})()


